import { render, staticRenderFns } from "./wig-page-header.vue?vue&type=template&id=c2db5784"
import script from "./wig-page-header.vue?vue&type=script&lang=js"
export * from "./wig-page-header.vue?vue&type=script&lang=js"
import style0 from "./wig-page-header.vue?vue&type=style&index=0&id=c2db5784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports